import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';
import { useThemeStore } from '../stores/theme-store';
import { ClientLoginForm } from '../components/auth/ClientLoginForm';
import { StaffLoginForm } from '../components/auth/StaffLoginForm';
import { ThemeToggle } from '../components/ui/ThemeToggle';
import { cn } from '../lib/utils';

export function LoginPage() {
  const [tab, setTab] = useState<'client' | 'staff'>('client');
  const user = useAuthStore((s) => s.user);
  const dark = useThemeStore((s) => s.dark);

  if (user) {
    return <Navigate to={user.role === 'CLIENT' ? '/' : '/admin'} replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center p-4 md:p-8">
      <div className="absolute right-6 top-6">
        <ThemeToggle />
      </div>
      <div className="grid w-full max-w-[1120px] gap-6 lg:grid-cols-[minmax(0,1fr)_420px]">
        <section className="app-shell-panel hidden rounded-[2rem] px-8 py-10 lg:flex lg:flex-col lg:justify-between">
          <div>
            <p className="app-kicker">Portal de suport Encorsa</p>
            <img src={dark ? '/logo_encorsa_ALB_mic.png' : '/logo_encorsa_COLOR_mic.png'} alt="Logo" className="mt-6 h-10 w-auto" />
            <h1 className="mt-10 text-[clamp(2.25rem,4vw,3.4rem)] font-semibold leading-[0.94] text-[color:var(--ink-strong)]">
              Intri rapid în portalul de suport.
            </h1>
            <p className="mt-4 max-w-[34ch] text-sm leading-6 text-[color:var(--ink-muted)] md:text-base">
              Dacă ești client, vezi și urmărești tichetele tale. Dacă faci parte din echipa Encorsa, intri din tabul Staff.
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-3">
            <div className="app-shell-panel-soft rounded-[1.35rem] p-4">
              <p className="app-kicker">Client</p>
              <p className="mt-3 text-sm font-semibold text-[color:var(--ink-strong)]">Deschizi tichet și vezi răspunsurile.</p>
            </div>
            <div className="app-shell-panel-soft rounded-[1.35rem] p-4">
              <p className="app-kicker">Echipă</p>
              <p className="mt-3 text-sm font-semibold text-[color:var(--ink-strong)]">Gestionezi și actualizezi tichetele.</p>
            </div>
            <div className="app-shell-panel-soft rounded-[1.35rem] p-4">
              <p className="app-kicker">Status</p>
              <p className="mt-3 text-sm font-semibold text-[color:var(--ink-strong)]">Verifici rapid stadiul solicitărilor.</p>
            </div>
          </div>
        </section>

        <div className="app-shell-panel rounded-[2rem] p-2 sm:p-3">
          <div className="px-4 pb-4 pt-5 sm:px-5 lg:hidden">
            <img src={dark ? '/logo_encorsa_ALB_mic.png' : '/logo_encorsa_COLOR_mic.png'} alt="Logo" className="h-9 w-auto" />
            <h1 className="mt-5 text-3xl font-semibold text-[color:var(--ink-strong)]">Autentificare</h1>
            <p className="mt-2 text-sm text-[color:var(--ink-muted)]">Alege Client sau Staff și continuă.</p>
          </div>

          <div className="rounded-[1.45rem] border border-[color:var(--surface-line)] bg-[var(--surface-panel-strong)] p-2">
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={() => setTab('client')}
                className={cn(
                  'rounded-full px-4 py-2.5 text-sm font-semibold transition-all duration-200',
                  tab === 'client'
                    ? 'bg-primary text-white shadow-[var(--shadow-soft)]'
                    : 'text-[color:var(--ink-muted)] hover:bg-[var(--surface-panel)] hover:text-[color:var(--ink-strong)]',
                )}
              >
                Client
              </button>
              <button
                onClick={() => setTab('staff')}
                className={cn(
                  'rounded-full px-4 py-2.5 text-sm font-semibold transition-all duration-200',
                  tab === 'staff'
                    ? 'bg-primary text-white shadow-[var(--shadow-soft)]'
                    : 'text-[color:var(--ink-muted)] hover:bg-[var(--surface-panel)] hover:text-[color:var(--ink-strong)]',
                )}
              >
                Staff
              </button>
            </div>
          </div>

          <div className="px-4 py-5 sm:px-5 sm:py-6">
            {tab === 'client' ? <ClientLoginForm /> : <StaffLoginForm />}
          </div>
        </div>
      </div>
    </div>
  );
}
